import { FC } from 'react';
import styled from 'styled-components';
import { NativeAuthManager } from '../../../managers/NativeAuth.manager';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    min-height: 100vh;
    background-color: #404040;
`;

const ContentLogin = styled.div`
    border-radius: 10px;
    background: #fff;
    padding: 30px;
    width: 95%;
    max-width: 320px;
    position: relative;
    box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
    text-align: center;
`;

const Title = styled.h2`
    text-align: left;
    font-size: 16px;
    margin-bottom: 10px;
    color: #0d0d0d;
    border-bottom: 1px solid #f6f6f6;
    padding: 15px;
    width: 100%;
`;

const BoxLogin = styled.form`
    width: 100%;
    padding: 10px;
`;

const InputField = styled.input`
    background-color: #f6f6f6;
    border: none;
    outline: none;
    color: #0d0d0d;
    padding: 10px 5px;
    font-size: 16px;
    margin-bottom: 10px;
    width: 100%;
    border: 2px solid #f6f6f6;
    border-radius: 4px;
    transition: 0.3s;

    &:focus {
        background-color: #fff;
        color: #ed9d56;
    }
`;

const Button = styled.input`
    width: 100%;
    background-color: #ed9d56;
    border: none;
    color: #fff;
    cursor: pointer;
    padding: 15px 80px;
    font-size: 18px;
    border-radius: 4px;
    transition: 0.3s;

    &:hover {
        background-color: #404040;
    }
`;

export const NativeAuthLoginPage: FC = () => {
    const handleButton = async () => {
        const requestdelogin = { email: '', password: '' };

        const nativeAuthManager = new NativeAuthManager(false);

        const request = await nativeAuthManager.loginWithEmail(requestdelogin.email, requestdelogin.password);

        console.log({ request });

        return;
    };
    return (
        <Wrapper>
            <ContentLogin>
                <Title>Login</Title>
                <BoxLogin method='post' action='#'>
                    <InputField type='email' name='email' placeholder='E-mail' />
                    <InputField type='password' name='senha' placeholder='Senha' />
                    <Button onClick={() => handleButton()} value='Entrar' />
                </BoxLogin>
            </ContentLogin>
        </Wrapper>
    );
};
